(function () {
  'use strict';

  if (window.PGProofTimingV62R2Installed) return;
  window.PGProofTimingV62R2Installed = true;

  var timer = null;
  var observer = null;

  function tidy(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function replaceTextNodes(root, replacer) {
    if (!root || !document.createTreeWalker) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];
    var node;

    while ((node = walker.nextNode())) nodes.push(node);

    nodes.forEach(function (textNode) {
      var before = String(textNode.nodeValue || '');
      var after = replacer(before);
      if (after !== before) textNode.nodeValue = after;
    });
  }

  function setText(node, value) {
    if (!node) return;
    if (tidy(node.textContent) !== tidy(value)) node.textContent = value;
  }

  function fixKnownCopy(block) {
    if (!block) return;

    var text = tidy(block.textContent);
    if (!text) return;

    /* Separate paid service: Next Day Preview genuinely remains a 24-hour option. */
    if (/next day preview/i.test(text)) return;

    /* Homepage benefit strip. */
    if (/^artwork proof in 1\s*(?:-|–|—)\s*2 days$/i.test(text)) {
      setText(block, 'Artwork proof in 2–3 working days');
      return;
    }

    /* Homepage FAQ. */
    if (/free artwork preview within 1\s*(?:-|–|—)\s*2 days/i.test(text) && !/standard orders/i.test(text)) {
      replaceTextNodes(block, function (value) {
        return value.replace(/within 1\s*(?:-|–|—)\s*2 days/gi, 'within 2–3 working days');
      });
      return;
    }

    /* Product / market FAQ where standard and priority timing appeared in one sentence. */
    if (/free artwork preview/i.test(text) && /first in line/i.test(text) && /standard orders/i.test(text)) {
      setText(
        block,
        'Yes — every order includes a free artwork preview. First In Line orders are prioritised within 2 working days, while standard orders are usually ready within 2–3 working days. Nothing goes to print until you’ve approved your proof.'
      );
      return;
    }

    /* Full FAQ page standard timing. Keep the separate busy-period allowance intact. */
    if (/most artwork previews are ready within 1\s*(?:-|–|—)\s*3 working days/i.test(text)) {
      replaceTextNodes(block, function (value) {
        return value.replace(/within 1\s*(?:-|–|—)\s*3 working days/gi, 'within 2–3 working days');
      });
      return;
    }

    /* First In Line is the priority 1–2 day service, expressed conservatively as within 2 working days. */
    if (/first in line/i.test(text) && /24 hours/i.test(text)) {
      replaceTextNodes(block, function (value) {
        return value.replace(/(?:usually delivered )?within 24 hours/gi, 'usually delivered within 2 working days');
      });
      return;
    }

    /* Shipping page. */
    if (/your artwork proof is usually sent within 3\s*(?:-|–|—)\s*5 working days/i.test(text)) {
      setText(
        block,
        'Your artwork proof is usually sent within 2–3 working days. During busy periods, please allow 3–5 working days. You can approve it or request edits.'
      );
      return;
    }

    /* Art Styles how-it-works page. */
    if (/you[’']ll receive your artwork proof within 3\s*(?:-|–|—)\s*5 working days/i.test(text)) {
      setText(
        block,
        'You’ll usually receive your artwork proof within 2–3 working days. During busy periods, please allow 3–5 working days. You can approve it or request changes before the final version is completed.'
      );
      return;
    }

    /* Yellow Art how-it-works page. */
    if (/your artwork proof is emailed within 3\s*(?:-|–|—)\s*5 working days/i.test(text)) {
      replaceTextNodes(block, function (value) {
        return value.replace(
          /your artwork proof is emailed within 3\s*(?:-|–|—)\s*5 working days/gi,
          'Your artwork proof is usually emailed within 2–3 working days. During busy periods, please allow 3–5 working days'
        );
      });
      return;
    }

    /* Legacy page blocks that can still be rendered by old section settings. */
    var proofContext = /proof|preview|sneak peek/i.test(text);
    var explicitBusyAllowance = /busy periods?|especially busy|peak periods?|peak season/i.test(text);
    var priorityContext = /first in line|next day preview|priority artwork/i.test(text);

    if (proofContext && !explicitBusyAllowance && !priorityContext) {
      replaceTextNodes(block, function (value) {
        return value
          .replace(/within 3\s*(?:-|–|—)\s*5 working days/gi, 'within 2–3 working days')
          .replace(/in 3\s*(?:-|–|—)\s*5 working days/gi, 'in 2–3 working days')
          .replace(/in just 3\s*(?:-|–|—)\s*5 working days/gi, 'in just 2–3 working days')
          .replace(/in 3\s*(?:-|–|—)\s*5 days/gi, 'in 2–3 working days');
      });
    }
  }

  function apply() {
    timer = null;

    /* Current homepage benefit component. */
    document.querySelectorAll('.pibb__item').forEach(function (item) {
      var heading = item.querySelector('.pibb__heading');
      if (heading && tidy(heading.textContent) === 'Proof Before Print') {
        setText(item.querySelector('.pibb__body'), 'Artwork proof in 2–3 working days');
      }
    });

    /* Product configurator reassurance. */
    setText(document.querySelector('.pg-cfg-proof strong'), '2–3 working days');

    /* Current FAQ / page copy plus any legacy theme-editor blocks still rendered. */
    document.querySelectorAll('p, li, dd, .pibb__body').forEach(fixKnownCopy);
  }

  function schedule(delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(apply, delay == null ? 0 : delay);
  }

  function boot() {
    apply();

    document.addEventListener('shopify:section:load', function () { schedule(0); });
    document.addEventListener('change', function () { schedule(20); }, true);
    document.addEventListener('click', function () { schedule(40); }, true);

    if (window.MutationObserver && document.body) {
      observer = new MutationObserver(function () { schedule(0); });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    [120, 500, 1200, 2500].forEach(function (delay) {
      window.setTimeout(apply, delay);
    });
  }

  window.PGProofTimingV62R2 = { apply: apply };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
